// extracted by mini-css-extract-plugin
export default {"header":"Auth_header__adEqy","isActive":"Auth_isActive__qmR7k","contianer":"Auth_contianer__YDV3Z","form":"Auth_form__KBP0A","actions":"Auth_actions__43Ofh"};